import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { useFetch } from 'providers/FetchProvider'
import { ChatSettings } from 'api/queries/chatSettings/types'
import { UpdateChatSettingsVariables } from './types'

const useUpdateChatSettingsMutation = (
  options?: UseMutationOptions<ChatSettings, Error, UpdateChatSettingsVariables>
): UseMutationResult<ChatSettings, Error, UpdateChatSettingsVariables> => {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const { fetch } = useFetch()

  const { onSuccess } = options || {}

  return useMutation(
    (variables: UpdateChatSettingsVariables) => (
      fetch.put('/chat-settings', variables).then((response) => response.data)
    ),
    {
      ...options,
      onSuccess: (data, ...rest) => {
        onSuccess?.(data, ...rest)
        enqueueSnackbar(t('aiSettings.action.success'), { variant: 'success' })
      },
      onError: () => {
        enqueueSnackbar(t('aiSettings.action.error'), { variant: 'error' })
      },
    },
  )
}

export { useUpdateChatSettingsMutation }
